import React from 'react'

const Context = React.createContext()

export default Context



// WEBPACK FOOTER //
// ./src/Context.js